import React from "react";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
export default function Intro() {
  return (
    <>
      <section className="hero">
        <div className="hero__bg">
          <img
            src={process.env.PUBLIC_URL + "/images/deal/hero-new.jpg"}
            alt="hero"
          />
        </div>
        <div className="auto__container hero">
          <div className="hero__inner">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div
                    data-aos="fade-up"
                    data-aos-delay={400}
                    className="aos-init aos-animate"
                  >
                    <motion.div
                      animate={{
                        scale: [0, 1.1, 1],
                        opacity: [0, 1],
                      }}
                    >
                      <div className="hero-container">
                        <div className="hero-backing-container">
                          <div className="hero-logos">
                            <div className="lm-logo">
                              <img
                                className="img-fluid"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/deal/lm-white.png"
                                }
                              />
                            </div>
                          </div>
                          {/* <div className="pre-title">Landmark Executive Roundtable Series</div> */}
                          <h1>
                            <span className="league-spartan-font bold">
                              DEAL<span className="teal-col">.</span>

                            </span>
                          </h1>        <div className="title-smaller league-spartan-font bold">
                             Landmark Executive Roundtable Series
                            </div>
                             <motion.div
                                    initial={{ opacity: 0, x: 20, y: 0 }} // Set your initial state
                                    animate={{opacity: 1, y: 0, x: 0 }} // Set your animation properties
                                    transition={{ duration: 0.9, ease: "easeOut" }}
                                  >
                                  <div>
                                    <div className="options-list">
                                      <div className="option-heading-text">
                                        <p>
                                          In a landscape defined by constant disruption, <b>DEAL – Dialogue on Exits, Acquisitions & Landscape</b>– offers a rare forum for unfiltered conversation and strategic connection. Curated and hosted by Landmark Ventures’ Investment Banking team, this off-the-record series is designed to illuminate what’s next: from emerging market signals to transformative deal opportunities.

                                        </p>
                                        <p className="option-heading-text-p">Each roundtable convenes an intimate group of senior executives, corporate development leaders, investors, and visionary founders to explore the evolving terrain of AdTech, MarTech, and Cybersecurity – where AI isn’t just a tool, but a fundamental shift shaping the next wave of transactions.
</p>
                                      </div>
                                      </div>
                                  </div></motion.div>
                        </div>

                        <div
                          data-aos="fade-up"
                          data-aos-delay={800}
                          className="aos-init aos-animate"
                        >
                          <div className="hero-btns">
                            <div className="hero-btn">
                              {/* <a
                                href="#apply"
                                type="button"
                                className="pink-btn no-grad simple"
                              >
                                APPLY
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>
                {/* <h1>
                      <span className="text-white">
                        Join Landmark Ventures @ CES 2025
                      </span>
                    </h1>
                    <p>
                      <span className="text-light">
                        We are pleased to host our annual LMV @ CES event
                        series, custom built for our robust network of Fortune
                        500 CMOs, Chief Digital Officer, Venture Capitalists,
                        Entrepreneurs, and Brand Executives across the digital
                        marketing, eCommerce, advertising, sports, social
                        impact, Web3, and media ecosystems.
                      </span>
                    </p>
                  </div>
                  {" "} */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="container narrower" style={{ marginTop: "20px" }}>
        <div className="cap-width">
          <div className="row hero-row-lower">
            <div className="col-12 col-md-6">
              <motion.div
                animate={{
                  x: [-200, 0],
                  opacity: [0, 1],
                }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              >
                <div className="header-img">
                  <img
                    className="img-fluid"
                    src={
                      process.env.PUBLIC_URL + "/images/unga/header-social.png"
                    }
                    alt="landmark-events"
                  />
                </div>
              </motion.div>
            </div>
            <div className="col-12 col-md-6">
              <motion.div
                animate={{
                  x: [50, 0],
                  opacity: [0, 1],
                }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              >
                <div className="header-text-container">
                  <div className="header-text">
                    Social Innovation Summit, along with our partners, are
                    delighted to host a series of VIP events for our network of
                    corporate responsibility executives, philanthropists,
                    investors, nonprofit leaders, policymakers, celebrity
                    activists, and social entrepreneurs across the global impact
                    ecosystem during UN General Assembly week 2024!
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
